import { getDialect } from '@terros/common'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHasEntitlement } from '../entitlement'
import { useProfile } from '../user'

export function useInitializeI18n(): void {
  const { user } = useProfile()
  const { i18n } = useTranslation()
  const isRecruiting = useHasEntitlement('recruiting')

  useEffect(() => {
    if (!user) return
    i18n.changeLanguage(isRecruiting ? 'en-Recruiting' : getDialect(user))
  }, [i18n, isRecruiting, user])
}
